<template>
  <div class="fix-content">
    <div class="header" @mouseenter="hoverHead = true" @mouseleave="hoverHead = false" :class="{white:currenWhite}">
      <div class="header-innder">
        <div class="title" @click.stop="jumpTo({path:'/'})">
          <img class="g2" :src="currenWhite || hoverHead?'/img/logo_white.png':'/img/logo_black.png'" width="30" height="40" alt="">
          <div class="name">
            <p>
              <span class="g1" v-for="(item,index) in '福建万福信息技术有限公司'" :key="index">{{item}}</span>
            </p>
            <span class="engli">
              <span class="g1" v-for="(item,index) in 'FUJIAN WANFU INFORMATION TECHNOLOGY CO.,LTD'" :key="index">{{item==' '?'&nbsp;':item}}</span>
            </span>
          </div>
        </div>
        <div class="menu">
          <ul class="top-menu">
            <li v-for="(item,index) in menuData" @click.stop="jumpTo(item)" :key="index">
              {{item.name}}
              <i v-if="item.children" class="iconfont Icon_arrow-down"></i>
              <ul v-if="item.children" class="child-menu">
                <li v-for="(subMenu,ind) in item.children" :key="ind">
                  <span class="sub-title" :class="{'no-sub':subMenu.hide}">{{subMenu.name}}</span>
                  <span class="son-title" v-for="(son,i) in subMenu.children" :key="i" @click.stop="jumpTo(son)">
                    {{son.name}}
                    <span v-if="son.status" :class="son.status" class="pro-status">{{son.status}}</span>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Transition leave-active-class="animate__animated animate__bounceOutDown" enter-active-class="animate__animated animate__bounceInUp">
      <div class="back-top" @click="goTop" v-if="showBackTop">
        <i class="iconfont backtop"></i>
      </div>
    </Transition>
  </div>
</template>

<script>
import gsap from 'gsap'
import { jumpTo } from '@/util.js'
export default {
  props: {
    white:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      scrollTop: 0,
      hoverHead: false,
      currenWhite: false,
      showBackTop: false,
      menuData: [
        {
          name: '首页',
          path: '/home'
        },
        {
          name: '核心能力',
          children: [
            // {
            //   name: '智慧水利',
            //   children: [
            //     {
            //       name: '水库雨水情在线测报平台',
            //       path: '/products/skysq',
            //       status: 'HOT'
            //     },
            //     {
            //       name: '水库大坝安全监测平台',
            //       path: '/products/skdbaq',
            //       status: 'NEW'
            //     },
            //     {
            //       name: '水资源综合管理平台',
            //       path: '/products/szyzhgl',
            //       status: ''
            //     },
            //     {
            //       name: '河湖智慧管理平台',
            //       path: '/products/hhzhgl',
            //       status: ''
            //     },
            //     {
            //       name: '山洪灾害防御指挥平台',
            //       path: '/products/shzhfw',
            //       status: ''
            //     },
            //   ]
            // },
            // {
            //   name: '智慧水务',
            //   children: [
            //     {
            //       name: '城乡供水一体化平台',
            //       path: '/products/cxgsyth',
            //       status: ''
            //     },
            //     {
            //       name: '污水管网智慧监管系统',
            //       path: '/products/wsgwzhjg',
            //       status: ''
            //     },
            //     {
            //       name: '城市排水防涝平台',
            //       path: '/products/cspsfl',
            //       status: ''
            //     },
            //     {
            //       name: '灌区信息化管理平台',
            //       path: '/products/gqxxhgl',
            //       status: ''
            //     },
            //   ]
            // },
            // {
            //   name: '智慧环保',
            //   children: [
            //     {
            //       name: '智慧环保管理平台',
            //       path: '/products/zhhbgl',
            //       status: ''
            //     },
            //     {
            //       name: '固危废AI监管平台',
            //       path: '/products/gwfjg',
            //       status: ''
            //     },
            //     {
            //       name: '农村生活污水智慧监管平台',
            //       path: '/products/ncshws',
            //       status: ''
            //     },
            //     {
            //       name: '大气治理信息化监管平台',
            //       path: '/products/dqzlxxh',
            //       status: ''
            //     },
            //     {
            //       name: '海漂垃圾综合治理平台',
            //       path: '/products/hpljzhzl',
            //       status: ''
            //     },
            //   ]
            // },
            {
              name: '智慧物联',
              hide: true,
              children: [
                {
                  name: 'VIMS视频能力服务平台',
                  path: '/pro_zhwl/spzngl',
                  status: 'HOT'
                },
                {
                  name: 'UMIoT元物联平台',
                  path: '/pro_zhwl/ywl',
                  status: ''
                },
                {
                  name: 'EAIGo视频智能分析系统',
                  path: '/pro_zhwl/spznfx',
                  status: ''
                },
                // {
                //   name: 'EAI智算精灵',
                //   path: '/pro_zhwl/zsjl',
                //   status: 'HOT'
                // },
              ]
            },
          ]
        },
        {
          name: '解决方案',
          children: [
            {
              name: '水环境',
              children: [
                {
                  name: '水环境综合管理平台',
                  path: '/solutions/szyzhgl',
                  status: ''
                },
                {
                  name: '河湖“四乱”综合整治',
                  path: '/solutions/hhslzl',
                  status: ''
                },
                {
                  name: '城市污水管网智慧监管',
                  path: '/solutions/wsgwzhjg',
                  status: 'NEW'
                },
                {
                  name: '农村生活污水智慧监管',
                  path: '/solutions/ncwszhjg',
                  status: ''
                },
                {
                  name: '海洋环境综合管理平台',
                  path: '/solutions/hpljzl',
                  status: ''
                },
              ]
            },
            {
              name: '水工程',
              children: [
                {
                  name: '智慧水库管理系统',
                  path: '/solutions/zhskgl',
                  status: 'HOT'
                },
                {
                  name: '灌区信息化系统',
                  path: '/solutions/gqxxhgl',
                  status: ''
                },
              ]
            },
            {
              name: '水资源',
              children: [
                {
                  name: '城乡供水一体化',
                  path: '/solutions/cxgsyth',
                  status: ''
                },
              ]
            },
            {
              name: '企业环保',
              children: [
                {
                  name: '固体废物和危险化学品管理',
                  path: '/solutions/gwfqlc',
                  status: ''
                },
                // {
                //   name: '企业污染源视频监控解决方案',
                //   path: '/solutions/gwfqlc',
                //   status: ''
                // },
              ]
            },
          ]
        },
        {
          name: '硬件产品',
          children: [
            {
              name: '视频边缘计算系列',
              children: [
                {
                  name: 'EAI智算精灵',
                  path: '/hardware/zsjl',
                  status: ''
                },
                {
                  name: '存算一体VGIS-N7100',
                  path: '/hardware/csyt',
                  status: 'NEW'
                }
              ]
            },
            {
              name: '物联网关系列',
              children: [
                {
                  name: '遥测终端机',
                  path: '/hardware/swyczd',
                  status: ''
                }
              ]
            },
            {
              name: '振弦采集系列',
              children: [
                {
                  name: '多通道振弦采集仪',
                  path: '/hardware/dtdzxcjy',
                  status: ''
                },
              ]
            },
            {
              name: '前端传感器系列',
              children: [
                {
                  name: '雨量计',
                  path: '/hardware/hyetometer',
                  status: ''
                },
                {
                  name: '气泡式水位计',
                  path: '/hardware/qpsswj',
                  status: ''
                },
                {
                  name: '雷达水位计',
                  path: '/hardware/ldswj',
                  status: ''
                },
                {
                  name: '振弦式渗压计',
                  path: '/hardware/zxssyj',
                  status: ''
                },
                {
                  name: '磁致式量水堰计',
                  path: '/hardware/czslsyj',
                  status: ''
                },
                {
                  name: '流量计',
                  path: '/hardware/flowmeter',
                  status: ''
                },
                {
                  name: '表面变形监测',
                  path: '/hardware/bmbxjc',
                  status: ''
                }
              ]
            },
            {
              name: '其他',
              children: [
                {
                  name: '水利一杆通WF-JC100',
                  path: '/hardware/slygt',
                  status: 'HOT'
                },
              ]
            },
          ]
        },
        {
          name: '项目案例',
          path: '/case',
        },
        // {
        //   name: '新闻资讯',
        //   path: '',
        // },
        {
          name: '关于我们',
          path: '/aboutUs',
        },
        {
          name: '联系我们',
          path: '/contactUs',
        },
      ]
    }
  },
  watch:{
    scrollTop(newV){
      this.showBackTop = newV>800
      this.currenWhite = this.white || newV>1
    },
    $route() {
      location.reload()
      window.scrollTo(0,0)
    },
  },
  mounted(){
    this.currenWhite = this.white
    this.g1()
    window.scrollTo(0,0)
    window.addEventListener('scroll', (e) => {
      this.scrollTop = e.target.documentElement.scrollTop;
    })
  },
  methods:{
    goTop(){
      let timer = setInterval(() => {
        this.scrollTop = this.scrollTop-=30
        if(this.scrollTop<0){
          this.scrollTop = 0
          clearInterval(timer)
        }
        window.scrollTo(0,this.scrollTop)
      }, 1);
    },
    g1(){
      const tl2 = gsap.timeline()
      tl2.fromTo('.g2',{rotation:180},{rotation:360})
      tl2.staggerFromTo('.g1',.1,{opacity:0},{opacity:1},.05)
    },
    jumpTo
  }
}
</script>

<style lang="scss" scoped>
.header{
  position: fixed;
  top: 0;
  height: 72px;
  width: 100%;
  z-index: 1000;
  cursor: default;
  transition: all .3s linear;
  &.white,&:hover{
    color: #333333 !important;
    background-color: #fff;
    box-shadow: 0px 4px 20px 0px rgba(187,191,194,0.50); 
    // border-bottom: 1px solid rgba(146, 156, 170, 0.3);
    // box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    .top-menu>li{
      color: #333333 !important;
    }
    .name{
      color: #035798 !important;
    }
  }
  .header-innder{
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title{
      display: flex;
      .name{
        display: flex;
        font-weight: bold;
        flex-direction: column;
        margin-left: 8px;
        color: #fff;
        p{
          font-size: 18px;
          letter-spacing: 4px;
        }
        .engli{
          font-size: 10px;
          transform: scale(0.8);
          transform-origin: left;
        }
      }
    }
    .menu{
      display: flex;
      height: 100%;
      .top-menu{
        display: flex;
        font-size: 16px; 
        &>li{
          display: flex;
          align-items: center;
          color: #fff;
          margin-left: 50px;
          text-align: center;
          cursor: pointer;
          position: relative;
          i{
            font-size: 10px;
            transform: scale(0.8);
            transition: all .25s linear;
            margin-left: 4px;
          }
          .child-menu{
            display: flex;
            position: absolute;
            top: 72px;
            // right: 0;
            // width: 1200px;
            transform: translateX(-50%);
            left: 0;
            overflow: hidden;
            height: 0;
            opacity: 0;
            color: #333333;
            font-weight: 400;
            background: #fcfcfc;
            transition: all .2s linear;
            box-shadow: 0px 3px 3px 1px rgba(178,187,196,0.50); 
            &>li{
              display: flex;
              flex-direction: column;
              width: 180px;
              text-align: left;
              margin-right: 64px;
              &:last-child{
                margin-right: 0;
              }
              .sub-title{
                font-weight: bold;
                padding-bottom: 12px;
                margin-bottom: 16px;
                border-bottom: 1px solid #dadfe7;
                &.no-sub{
                  display: none;
                }
              }
              .son-title{
                display: flex;
                margin-bottom: 16px;
                font-size: 14px;
                .pro-status{
                  font-weight: bold;
                  margin-left: 4px;
                  animation: heartbeat 0.5s linear infinite;
                }
                .HOT{ 
                  color: #E10000;
                }
                @keyframes heartbeat{
                  0%{
                    transform: scale(0.8);
                  }
                  50%{
                    transform: scale(1.1);
                  }
                  100%{
                    transform: scale(0.8);
                  }

                }
                .NEW{
                  color: #FF7040;
                }
                &:hover,&.active{
                  color: #0B68BF;
                  font-weight: bold;
                }
              }
            }
          }
          &.active,&:hover{
            color: #0B68BF !important;
            font-weight: bold;
            i{
              transform: rotate(180deg);
            }
            .child-menu{
              opacity: 1;
              padding: 32px 48px;
              height: auto;
            }
          }
        }
      }
    }
  }
}
.back-top{
  position: fixed;
  right: 10px;
  bottom: 80px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  box-shadow: 0 4px 10px 0 rgb(138 141 147 / 20%);
  &:hover{
    color: #0b68bf;
  }
}
</style>